import React from "react"
import { BrowserRouter } from "react-router-dom"
import { Theme, SnackbarProvider } from "@citydna/common"

import { Layout } from "./Layout"
import { AppRoutes } from "./AppRoutes"
import { AuthProvider } from "./AuthProvider"
import { DataProvider } from "./DataProvider"

import Amplify from "aws-amplify"
import config from "../aws-exports"
import { MapViewProvider } from "./MapProvider"
import { HeightProvider } from "./HeightProvider"
import { ErrorBoundary } from "./ErrorBoundary"
Amplify.configure(config)

export const App: React.FC = () => {
  return (
    <Theme>
      <ErrorBoundary>
        <SnackbarProvider>
          <BrowserRouter>
            <AuthProvider>
              <DataProvider>
                <MapViewProvider>
                  <HeightProvider>
                    <Layout>
                      <ErrorBoundary>
                        <AppRoutes />
                      </ErrorBoundary>
                    </Layout>
                  </HeightProvider>
                </MapViewProvider>
              </DataProvider>
            </AuthProvider>
          </BrowserRouter>
        </SnackbarProvider>
      </ErrorBoundary>
    </Theme>
  )
}
